import React, { useState } from "react";
import {
  Button,
  FlexRowBetween,
  FlexRowStart,
  GenericDiv,
  Input,
  Label,
  PopupForm,
  RespFont,
  TextArea,
} from "../common/Style";
import Switcher from "../common/switcher/Switcher";
import {
  destroyUser,
  editUserById,
  ipus,
} from "../../store/reducers/userReducer";
import { toast } from "react-toastify";
import YesNoModal from "../common/modals/YesNoModal";
import {
  aviadPayment,
  CFV,
  exportToCSV,
  getImageUrl,
  igalPmPayment,
  links,
  liorWDPayment,
  msg4,
  msg4B,
  msg4nBS,
  msg4nC,
  PolPayment,
  RazPayment,
  TipTopPayment,
  TomerPayment,
  yosefPayment,
} from "../common/others/Functions";
import GCalendar from "../common/calendar/Calendar";
import GenericModal from "../common/modals/GenericModal";
import OpacityLoading from "../common/loader/OpacityLoading";
import trash from "../../assets/common/trash.svg";
import call from "../../assets/common/call.svg";
import excel from "../../assets/common/excel.svg";

import galleryWhite from "../../assets/common/galleryWhite.svg";
import notes from "../../assets/common/notes.svg";
import whatsappW from "../../assets/common/whatsappW.svg";
import tools from "../../assets/common/menu.svg";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Stats from "./Stats";
import {
  adminSetPaid,
  countNotAnswered,
  sendGenericSms,
  syncSeatup,
} from "../../store/reducers/dataReducer";
import EditPics from "../common/others/EditPics";
import EditPicsAdmin from "../common/others/EditPicsAdmin";
import CopyText from "../common/others/CopyText";
import { getAllGAvivit } from "../../store/reducers/guestsReducer";
import {
  createIBSuser,
  getIBSuser,
} from "../../store/reducers/paymentsReducer";

const ADMIN_SET_PAID_PASSWORD = "999888";

const EditUser = ({ user, init }) => {
  const { isItay } = useSelector((state) => state.authReducer.user);
  const dispatch = useDispatch();
  const [editPic, setEditPic] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [amount, setAmount] = useState(0);
  const [isDigitalSeat, setIsDigitalSeat] = useState(user.isDigitalSeat);
  const [sendSeatSMS, setSendSeatSMS] = useState(user.sendSeatSMS);
  const [schk, setSCHK] = useState(user.schk);
  const [uRole, setURole] = useState(user.role);
  const [isPaid, setIsPaid] = useState(user.isPaid);
  const [isReadyAdminPrev, setIsReadyAdminPrev] = useState(user.isReadyAdmin);
  const [isReadyAdmin, setIsReadyAdmin] = useState(user.isReadyAdmin);
  const [canChangeTodos, setCanChangeTodos] = useState(user.canChangeTodos);
  const [loading, setLoading] = useState(false);
  const [showStats, setShowStats] = useState(false);
  const [showAsmachta, setShowAsmachta] = useState(false);
  const [show180dealAcceptExtra, setShow180dealAcceptExtra] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showIpus, setShowIpus] = useState(false);
  const [showCalendar, setShowCalendar] = useState(null);
  const [showAdminSetPaidModal, setShowAdminSetPaidModal] = useState(false);
  const [adminSetPaidPassword, setAdminSetPaidPassword] = useState("");
  const [adminSetPaidAmountInput, setAdminSetPaidAmountInput] = useState("0");

  let mm = user.eventType
    ? `*ביצוע סרטון ״מזמין + קשר״*\nhttps://youtu.be/HRx9ewK3pHY\n\nמגביר משמעותית את המענה והופך את ההזמנה לאישית ומכבדת יותר 🙏\n\n`
    : ``;
  let prod =
    user.producer.toLowerCase() == "callup"
      ? "קולאפ מבית סיטאפ"
      : user.producer;
  let pri =
    user.producer.toLowerCase() == "callup" ||
    user.producer.toLowerCase() == "TomerIsakov"
      ? " (עלות השירות - 200₪)"
      : user.producer == "LetMeSit" ||
          user.producer == "שמחת עולם" ||
          user.producer == "משחק הכיסאות" ||
          user.producer == "TipTop" ||
          user.producer == "מארגנת החתונות"
        ? " (עלות השירות - חינם)"
        : user.producer == "שלי חסווה הפקות" || user.producer == "דובי הפקות"
          ? " (עלות השירות - 99₪)"
          : user.producer == "Arrivo"
            ? " (עלות השירות - 50₪)"
            : " (עלות השירות - 100₪)";
  let ss =
    user.producer == "BeSimple" ||
    user.producer == "Let_Me_sit" ||
    user.producer == "Arrivo"
      ? "*הרבה אירועים אף מוסיפים 20 אגורות לרשומה על מנת שהודעת התזכורת עם האופציה למתנה באשראי תישלח גם בווצאפ מלבד הסמס כדי להגביר את החשיפה*"
      : "*בנוסף, הודעת התזכורת תצא באמצעות הווצאפ מלבד ה sms שמגיע בחבילה על מנת להגביר את החשיפה*";
  let ex = "https://l5k.me/Vzf2m";
  let link = `https://callup.ltd/`;
  if (links[user.producer] != undefined) link = links[user.producer];
  let msg0 = `לינק להתחברות - ${link}\n\nמס׳ נייד - ${user.phone}\n\nסיסמא - ${user.vPassword}`;
  let msg1 = `*מתנות באשראי* - השירות החשוב ביותר: ${pri}\nהרי לא כל המוזמנים יגיעו, נכון יהיו את אלה שיעבירו מתנה בכל זאת אבל יש הרבה שלא...\nיום האירוע תישלח הודעת תזכורת לכלל האורחים עם האופציה למתנה באשראי (גם עבור אורחים שלא יגיעו) וסביר מאוד שיהיו אורחים שבסוף כן ישלחו מתנה בעקבות ההודעה מתוך כבוד כאשר רואים את האופציה בהודעה מול העיניים\nהרבה זוגות שלא רצו בהתחלה והשתכנעו הודו לנו לאחר החתונה שראו את רשימות האורחים שנתנו מתנה באשראי ואמרו בפירוש שלא בטוח היו שולחים בדרך אחרת\nאין אירוע שלא לוקח את השירות הזה - אל תחסירו מהאורח את האופציה הזו, מה גם שזה נוח גם עבור אורחים שכן מגיעים לאירוע במקום לעצור להוציא מזומן\n${ss}\n\nעדכנו אותי האם להוסיף אתכם לשירות`;
  let msg2 = `היי, מדברים מחברת ${prod} - אישורי ההגעה שלכם!\nעוד פחות מחודש האירוע ובימים הקרובים צריך להתחיל אישורי הגעה, אנא שלחו לנו את ההזמנה והאקסל במידה ועוד לא עשיתם זאת 🙏`;
  let msg3 = `היי חברה חייב להתחיל את אישורי ההגעה, איחור מצידכם יגרור עיכוב משמעותי בקבלת התשובות שלכם -> תשובה מאוחרת לאולם על כמויות והושבה סמוכה לאירוע תחת לחץ בימים הקריטיים והלחוצים לפני החתונה`;
  let msg5 = `${mm}*ביצוע סרטון ״חינמיים + ללא מספר״*\nאנא צפו בסרטון הבא שמראה למי חסר מספר במערכת ותמלאו על מנת שנוכל לבדוק האם יגיעו, בנוסף תאשרו בעצמיכם רשומות שאין צורך שנבדוק לגבי הגעתם\n\nhttps://youtu.be/i2flhaDAyNc\n\n*אין יותר שימוש באקסל, מעכשיו כל שינוי יהיה ישירות במערכת.*\n*במידה ותרצו להוסיף אנשים מעכשיו ניתן להוסיף ידני - https://youtu.be/4h9PZpL8Gv8*`;
  // if (user.isKenes == false)
  //   msg5 = `אנא קראו היטב את כל מרכיבי ההודעה ועדכנו אותי לאחר ביצוע הנדרש, בנוסף עדכנו האם להוסיף אתכם לשירות המתנות באשראי המוסבר בהמשך ההודעה 🙏\n\n${msg5}\n\n${msg1}`;
  // else
  msg5 = `אנא קראו היטב את כל מרכיבי ההודעה ועדכנו אותי לאחר ביצוע הנדרש 🙏\n\n${msg5}`;
  const [date, setDate] = useState(new Date(user.date));
  const [showLoading, setShowLoading] = useState(false);

  const handleSetDate = (e) => {
    let date1 = e;
    date1.setHours(20);
    setDate(date1);
  };

  const handleSyncSeatup = (uid, seatupEventId) => {
    dispatch(syncSeatup({ uid, seatupEventId })).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        init();
      } else toast.error(res.payload?.error);
    });
  };

  const handleCreateIBSuser = () => {
    if (user.eventType && user.brideFN === "")
      toast.error(
        "יש להשלים פרטי אירוע, אם כבר בוצע אולי יש לרענן עמוד זה ואז לנסות ליצור לינק",
      );
    else {
      setLoading(true);
      dispatch(
        createIBSuser({
          phone: user.phone.substring(1),
          uniqueDescription: user.eventType
            ? `החתונה של ${user.brideFN + " " + user.brideLN} ו${
                user.groomFN + " " + user.groomLN
              }`
            : user.calendarName,
          producer: user.producer,
          eventDate: date,
        }),
      ).then((res) => {
        setLoading(false);
        if (!res.payload?.error) toast.success("הפעולה בוצעה בהצלחה");
        else toast.error(res.payload?.error);
      });
    }
  };

  const handleGetIBSDetails = () => {
    setLoading(true);
    dispatch(
      getIBSuser({
        phone: user.phone.substring(1),
      }),
    ).then((res) => {
      setLoading(false);
      if (!res.payload?.error) {
        toast.info(
          <CopyText
            marginLeft={"5px"}
            dataToCopy={`קישור: https://i-b-s.site/\nנייד להתחברות: 0${res.payload.phone}\nסיסמא: ${res.payload.password}`}
            text={"פרטים"}
          />,
        );
      } else toast.error(res.payload?.error);
    });
  };

  const handleSmsItayOnDeal180 = (phone) => {
    let body = {
      Data: {
        Message: "[#msg#]",
        Recipients: [
          {
            msg: `חדש ${phone}`,
            Phone: "547439322",
          },
        ],
        Settings: {
          Sender: "deal180",
        },
      },
    };
    dispatch(sendGenericSms(body)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        init();
      } else toast.error(res.payload?.error);
    });
  };

  const onSubmit = async (data) => {
    let phone = data.phone || "";
    phone = phone.replaceAll("-", "");
    phone = phone.replaceAll(/[^\d]/g, "");
    const body = {
      ...data,
      date: date.toISOString(),
      isPaid,
      isReadyAdmin,
      mikdama: parseFloat(data.mikdama) || 0,
      schk,
      role: uRole,
      sendSeatSMS,
      isDigitalSeat,
      // producer: "BeSimple",
      restRecordsAtFirstCall: isItay
        ? data.restRecordsAtFirstCall || 0
        : user.restRecordsAtFirstCall,
      canChangeTodos,
      // calendarName: user.eventType ? "" : data.calendarName,
      phone,
      deal: parseFloat(data.deal) || 0,
      // payboxTax: parseFloat(data.payboxTax) || 0,
    };
    dispatch(editUserById(user._id, body)).then((res) => {
      if (!res.payload?.error) {
        if (isReadyAdminPrev == false && isReadyAdmin == true) {
          if (
            user.producer != "דובי הפקות" &&
            user.producer != "שלי חסווה הפקות"
          )
            if (user.role == 5)
              toast.info(
                "אביביתוש שלחי להם קודם הסבר על נושא תשלום הרשומות למען אישורי הגעה תקינים ואז תשלחי לאחר מכן את האשראי",
              );
            else toast.info("אביביתוש שלחי להם אשראי חחח");
          else
            toast.info(
              "אביביתוש בגלל שזה לקוח של דובי/שלי הפקות אנחנו לא מציעים את השירות אבל תראי אם הוא ציין בהערות שיש להם אז רק לפתוח ולעדכן את הזוג שקיבל סמס לאישור התקנון",
            );
        }
        toast.success("הפעולה בוצעה בהצלחה");
        init();
      } else toast.error(res.payload?.error);
    });
  };

  const getAllExcel = (guests) => {
    let arr = [];
    if (Object.keys(guests).length > 0)
      for (const [key, value] of Object.entries(guests)) {
        arr.push({
          "שם מלא": value.name,
          "מס׳ נייד": value.phone,
          קירבה: value.closeness,
          מוזמנים: value.sum,
          אישרו: value.accept === null ? "" : value.accept,
          מזמין: value.inviting,
          קשר: value.owc,
          הערות: value.notes,
        });
      }
    exportToCSV(arr, "כללי");
  };

  const handleGetGuests = (uid) => {
    setShowLoading(true);

    dispatch(getAllGAvivit(uid)).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else getAllExcel(res.payload);
      setShowLoading(false);
    });
  };

  const handleAdminSetPaid = (uid, amountOverride) => {
    const recordsAmount =
      amountOverride !== undefined && amountOverride !== null
        ? amountOverride
        : amount;
    setShowLoading(true);
    // console.log("uid: ",uid);
    // console.log("amount: ",recordsAmount);

    dispatch(adminSetPaid({ uid, amount: recordsAmount })).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else toast.info("הפעולה בוצעה בהצלחה - רענן לבדיקה");
      setShowLoading(false);
    });
  };

  const openAdminSetPaidModal = (e) => {
    e.preventDefault();
    setAdminSetPaidPassword("");
    setAdminSetPaidAmountInput(String(amount));
    setShowAdminSetPaidModal(true);
  };

  const handleAdminSetPaidModalSubmit = () => {
    if (adminSetPaidPassword !== ADMIN_SET_PAID_PASSWORD) {
      toast.warning("סיסמת מנהל שגויה");
      return;
    }
    const parsedAmount = Number(adminSetPaidAmountInput);
    if (!Number.isFinite(parsedAmount) || parsedAmount < 0) {
      toast.warning("יש להזין כמות רשומות תקינה");
      return;
    }
    setAmount(parsedAmount);
    setShowAdminSetPaidModal(false);
    handleAdminSetPaid(user._id, parsedAmount);
  };

  const handleCountNotAnswered = (uid) => {
    setShowLoading(true);
    dispatch(countNotAnswered({ uid })).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else
        toast.info(
          <FlexRowBetween>
            <div>{res.payload.waze.length ? "✔️" : "❌"}</div>
            <div>{res.payload.amount}</div>
            <img
              src={excel}
              style={{ width: "25px" }}
              onClick={() => {
                if (res.payload.eventType) handleGetGuests(uid);
                else
                  toast.info(
                    "לא מדובר בחתונה ולכן אין אפשרות לבעל השמחה לעשות מזמין + קשר, שווה לבדוק האם לעשות לו או שאפשר משהו כולל - ניתן לראות לפי הקטגוריות",
                  );
              }}
            />
          </FlexRowBetween>,
        );

      setShowLoading(false);
    });
  };

  const handleIpus = async () => {
    setLoading(true);
    dispatch(
      ipus({
        id: user._id,
        pic: user.pic,
      }),
    ).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else {
        toast.success("הפעולה בוצעה בהצלחה!");
        setShowDelete(false);
        init(null);
      }
      setLoading(false);
    });
  };

  const handleDestroyUser = async () => {
    setLoading(true);
    dispatch(
      destroyUser({
        id: user._id,
        pic: user.pic,
        asmachta: user.asmachta,
        sketch: user.sketch,
        is180dealAcceptExtra: user.is180dealAcceptExtra,
      }),
    ).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else {
        toast.success("הפעולה בוצעה בהצלחה!");
        setShowDelete(false);
        init(null);
      }
      setLoading(false);
    });
  };

  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      onSubmit={handleSubmit(onSubmit)}
      className="animate__animated animate__fadeIn"
      style={{ position: "relative" }}
    >
      <GenericDiv
        onClick={() => setShowStats(user)}
        style={{
          position: "absolute",
          left: "0",
          top: "0",
          borderRadius: "0 0 20px 0",
          padding: "5px 9px 9px 9px",
        }}
        background={"rgba(123,150,196,0.95)"}
      >
        <img src={tools} alt="tools" style={{ width: "25px" }} />
      </GenericDiv>

      <RespFont
        onClick={() => setShowStats(user)}
        style={{
          position: "absolute",
          right: "10px",
          top: "5px",
        }}
      >
        {user.producer}
      </RespFont>
      <div
        style={{
          width: "90%",
          margin: "15px auto",
          marginTop: "40px",
        }}
      >
        {/* {!user.eventType && (
          <>
            <Label>תיאור האירוע</Label>
            <Input
              value={user.calendarName}
              // disabled={true}
              type="text"
              {...register("calendarName", {
                required: true,
                minLength: 2,
                maxLength: 100,
              })}
            />
            <span>צריך להתאים לתבניות ההודעות</span>
            <br />
            <span>לכן צריך להיות לדוגמא:</span>
            <br />
            <span>אירוע בר המצווה של רועי כהן</span>
            {CFV("calendarName", "בין 2 ל 100 תווים", errors)}
          </>
        )} */}

        <FlexRowBetween>
          <div style={{ width: "65%" }}>
            <Label>ניווט</Label>
            <Input
              value={user.waze}
              // disabled={true}
              // type="text"
              // {...register("waze", {
              //   minLength: 0,
              //   maxLength: 50,
              // })}
            />
            {/* {CFV("waze", "בין 2 ל 20 תווים", errors)} */}
          </div>
          <div style={{ width: "30%" }}>
            <Label>דיל (₪)</Label>
            <Input
              defaultValue={user.deal}
              type="number"
              step={0.05}
              {...register("deal", {
                required: true,
                min: 0,
                max: 3,
              })}
            />
            {CFV(`deal`, `מספר בין 0 ל 3`, errors)}
          </div>
        </FlexRowBetween>

        <FlexRowBetween>
          <div style={{ width: "65%" }}>
            <Label>אשראי</Label>
            <Input
              value={user.paybox}
              // disabled={true}
              type="text"
              {...register("paybox", {
                minLength: 0,
                maxLength: 50,
              })}
            />
            {CFV("paybox", "בין 2 ל 20 תווים", errors)}
          </div>

          <div style={{ width: "20%" }}>
            <Label>מק׳ (₪)</Label>
            <Input
              defaultValue={user.mikdama}
              type="number"
              step={0.5}
              {...register("mikdama", {
                required: true,
                min: 0,
                max: 10000,
              })}
            />
            {CFV(`mikdama`, `מספר בין 0 ל 10000`, errors)}
          </div>
        </FlexRowBetween>

        <FlexRowBetween style={{ alignItems: "baseline" }}>
          <div style={{ width: "35%" }}>
            <Label>מס׳ נייד</Label>
            <Input
              defaultValue={user.phone}
              {...register("phone", {
                pattern: /^[0]{1}[5]{1}[0-9]{8}$/,
              })}
            />
            {CFV("phone", "פורמט מספר פלאפון לא חוקי", errors)}
          </div>
          <div style={{ width: "35%" }}>
            <Label>תאריך</Label>
            <Input
              onClick={() => setShowCalendar(true)}
              value={date
                .toISOString()
                .replace(/T.*/, "")
                .split("-")
                .reverse()
                .join("/")}
              onChange={() => {}}
              type={"text"}
            />
          </div>
          <div style={{ width: "20%" }}>
            <Label>שיחות</Label>
            <Input
              defaultValue={user.restRecordsAtFirstCall}
              disabled={!isItay}
              type="number"
              {...register("restRecordsAtFirstCall", {
                min: 0,
                max: 100000,
              })}
            />
            {CFV(`restRecordsAtFirstCall`, `מספר בין 0 ל 100000`, errors)}
          </div>
        </FlexRowBetween>

        <Label>הערות</Label>
        <TextArea
          defaultValue={user.description}
          type="text"
          rows="2"
          {...register("description", {
            minLength: 0,
            maxLength: 500,
          })}
        />
        {CFV("description", "עד 500 תווים", errors)}
        {/* <div style={{ width: "100%", overflowX: "auto" }}></div> */}
        <FlexRowBetween>
          <div style={{ width: "max-content", textAlign: "right" }}>
            <Label>לינק בקדם</Label>
            <Switcher
              onOfColor={"#C0C0C0"}
              color={"#7b96c4"}
              checked={schk}
              onChange={() => setSCHK(!schk)}
            />
          </div>
          {user.producer == "CallUp" ||
          user.producer == "LetMeSit" ||
          user.producer == "שלי חסווה הפקות" ||
          user.producer == "דובי הפקות" ||
          user.producer == "Let_Me_Sit" ||
          user.producer == "BeSimple" ? (
            <div style={{ width: "max-content", textAlign: "right" }}>
              <Label>תשלום מראש</Label>
              <Switcher
                onOfColor={"#C0C0C0"}
                color={"#7b96c4"}
                checked={uRole == 5}
                onChange={() => setURole(uRole == 5 ? 1 : 5)}
              />
            </div>
          ) : null}
          <div style={{ width: "max-content", textAlign: "right" }}>
            <Label
              onContextMenu={() =>
                handleSyncSeatup(user._id, user.seatupEventId)
              }
            >
              הושבה
            </Label>
            <Switcher
              onOfColor={"#C0C0C0"}
              color={"#7b96c4"}
              checked={isDigitalSeat}
              onChange={() => setIsDigitalSeat(!isDigitalSeat)}
            />
          </div>
          {isDigitalSeat && (
            <div style={{ width: "max-content", textAlign: "right" }}>
              <Label>דיגיטלית</Label>
              <Switcher
                onOfColor={"#C0C0C0"}
                color={"#7b96c4"}
                checked={sendSeatSMS}
                onChange={() => setSendSeatSMS(!sendSeatSMS)}
              />
            </div>
          )}
          {/* <div style={{ width: "max-content", textAlign: "right" }}>
            <Label
              style={{ marginLeft: "0px", textAlign: "right" }}
              onContextMenu={() => handleSyncSeatup(user._id)}
            >
              רשאי לוז?
            </Label>
            <Switcher
              onOfColor={"#C0C0C0"}
              color={"#7b96c4"}
              checked={canChangeTodos}
              onChange={() => setCanChangeTodos(!canChangeTodos)}
            />
          </div> */}
        </FlexRowBetween>
        <FlexRowBetween style={{ marginTop: "10px" }}>
          <div style={{ width: "max-content", textAlign: "right" }}>
            <Label onContextMenu={openAdminSetPaidModal}>שולם?</Label>
            <Switcher
              onOfColor={"#C0C0C0"}
              color={"#7b96c4"}
              checked={isPaid}
              onChange={() => setIsPaid(!isPaid)}
            />
          </div>
          <div style={{ width: "max-content", textAlign: "right" }}>
            <Label
              onClick={() => {
                handleCountNotAnswered(user._id);
              }}
            >
              מוכן?
            </Label>
            <Switcher
              onOfColor={"#C0C0C0"}
              color={"#7b96c4"}
              checked={isReadyAdmin}
              onChange={() => setIsReadyAdmin(!isReadyAdmin)}
            />
          </div>
          {user.asmachta !== "" && (
            <GenericDiv
              onClick={() => setShowAsmachta(true)}
              style={{ width: "min-content", marginTop: "10px" }}
            >
              צפיה באסמכתא
            </GenericDiv>
          )}
          <>
            <div style={{ width: "100px", textAlign: "right" }}>
              <Label>הושבה (₪)</Label>
              <Input
                defaultValue={user.digitalSeatCost}
                type="number"
                {...register("digitalSeatCost", {
                  required: true,
                  min: 0,
                  max: 10000,
                })}
              />
              {CFV(`digitalSeatCost`, `מספר בין 0 ל 10000`, errors)}
            </div>
            <div style={{ width: "100px", textAlign: "right" }}>
              <Label>מתנות (₪)</Label>
              <Input
                defaultValue={user.giftCost}
                type="number"
                {...register("giftCost", {
                  required: true,
                  min: 0,
                  max: 300,
                })}
              />
              {CFV(`giftCost`, `מספר בין 0 ל 300`, errors)}
            </div>
          </>
        </FlexRowBetween>

        <FlexRowBetween style={{ marginTop: "2px" }}>
          <CopyText
            marginLeft={"5px"}
            dataToCopy={msg0}
            text={"התחברות"}
            padding="4px"
            image={false}
          />
          <CopyText
            marginLeft={"5px"}
            dataToCopy={"https://wedding-harmony-2587b071.base44.app/"}
            text={"תיאום ציפיות"}
            padding="4px"
            image={false}
          />
          <CopyText
            marginLeft={"5px"}
            dataToCopy={msg5}
            text={"פינישים"}
            padding="4px"
            image={false}
          />

          <CopyText
            marginLeft={"5px"}
            // dataToCopy={
            //   user.producer == "משחק הכיסאות"
            //     ? aviadPayment
            //     : user.producer == "TipTop"
            //       ? TipTopPayment
            //       : user.producer == "TomerIsakov"
            //         ? TomerPayment
            //         : user.producer == "קליקסיט"
            //           ? PolPayment
            //           : user.producer == "מארגנת החתונות"
            //             ? liorWDPayment
            //             : user.producer == "שמחת עולם"
            //               ? yosefPayment
            //               : user.producer == "RN_EVENTS"
            //                 ? RazPayment
            //                 : user.producer == "PM ניהול והפקות אירועים"
            //                   ? igalPmPayment
            //                   : user.paybox !== "" && user.paybox !== null
            //                     ? msg4B
            //                     : msg4nBS
            // }
            dataToCopy={
              "*אנא אשרו לי שקראתם את ההודעה הבאה על מנת שנעבור לשלב הבא:*\n\nחשוב מאוד להבין שאישורי ההגעה יישלחו רק לרשומות אשר שילמתם עליהם.\n\n*מהרגע שתאשרו לנו להתחיל תהליך ע״י לחיצה על הכפתור בעמוד הראשי של האתר - תהבהב הודעת מערכת בצבע אדום במידה ויש חלק מהאורחים שלא שילמתם עליהם - אם מעולם לא שילמתם זה הזמן להיכנס ולשלם על מנת שנוכל להתחיל בתהליך*\n\nולכן, כל מי שמוסיף אורח תוך כדי התהליך צריך לשלם באותו רגע כדי שהאורח שהתווסף אכן ייכנס להמשך התהליך ולא יפספס סבבים"
            }
            text={"הסבר תשלום"}
            padding="4px"
            image={false}
          />
        </FlexRowBetween>

        <FlexRowBetween style={{ marginTop: "15px" }}>
          <div
            onClick={handleCreateIBSuser}
            style={{
              borderRadius: "5px",
              border: "1px solid rgba(0, 0, 0, 0.11)",
              cursor: "pointer",
              fontSize: "12px",
              padding: "4px",
            }}
          >
            פתיחת אשראי
          </div>
          {user.producer != "דובי הפקות" &&
            user.producer != "שלי חסווה הפקות" && (
              <CopyText
                marginLeft={"5px"}
                dataToCopy={msg1}
                text={"הסבר אשראי"}
                padding="4px"
                image={false}
              />
            )}
          <div
            onClick={handleGetIBSDetails}
            style={{
              borderRadius: "5px",
              border: "1px solid rgba(0, 0, 0, 0.11)",
              cursor: "pointer",
              fontSize: "12px",
              padding: "4px",
            }}
          >
            פרטי אשראי
          </div>
        </FlexRowBetween>
        <FlexRowBetween style={{ marginTop: "30px" }}>
          <a
            href={
              "tel:" +
              (user.phone[0] === "0" ? user.phone : "0" + user.phone + "")
            }
          >
            <GenericDiv
              background={"rgba(123,150,196,0.95)"}
              style={{ padding: "8px 8px" }}
            >
              <img src={call} alt={"call"} style={{ width: "23px" }} />
            </GenericDiv>
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href={`https://wa.me/972${user.phone}/?text=`}
          >
            <GenericDiv
              background={"rgba(123,150,196,0.95)"}
              style={{ margin: "0 20px", padding: "4px 4px" }}
            >
              <img
                src={whatsappW}
                alt={"whatsappW"}
                style={{ width: "31px" }}
              />
            </GenericDiv>
          </a>
          <Button style={{ width: "100%" }}>שמירה</Button>
          <GenericDiv
            onClick={() => setShowDelete(true)}
            background={"rgba(41,59,90,0.95)"}
            style={{ marginRight: "20px", padding: "9px 10px" }}
          >
            <img src={trash} alt="trash" style={{ width: "21px" }} />
          </GenericDiv>
          <GenericDiv
            onClick={() => setShowIpus(true)}
            background={"rgba(41,59,90,0.95)"}
            style={{
              marginRight: "20px",
              padding: "9px 10px",
              fontSize: "14px",
            }}
          >
            איפוס
          </GenericDiv>
        </FlexRowBetween>
      </div>

      {loading && <OpacityLoading />}

      {showCalendar && (
        <GenericModal
          init={setShowCalendar}
          div={
            <GCalendar
              setDate={handleSetDate}
              date={date}
              init={setShowCalendar}
            />
          }
        />
      )}

      {showStats && (
        <GenericModal init={setShowStats} div={<Stats user={showStats} />} />
      )}

      {showAsmachta && (
        <GenericModal
          init={setShowAsmachta}
          div={
            <img
              src={`${getImageUrl()}${user._id}/${user.asmachta}`}
              style={{ width: "90%", maxWidth: "500px" }}
            />
          }
        />
      )}

      {showDelete && (
        <GenericModal
          init={setShowDelete}
          div={
            <YesNoModal
              title={"מחיקת אירוע"}
              body={"האם את/ה בטוח/ה שברצונך למחוק אירוע זה?"}
              no={setShowDelete}
              yes={handleDestroyUser}
            />
          }
        />
      )}

      {showIpus && (
        <GenericModal
          init={setShowIpus}
          div={
            <YesNoModal
              title={"איפוס אירוע"}
              body={"האם את/ה בטוח/ה שברצונך לאפס אירוע זה?"}
              no={setShowIpus}
              yes={handleIpus}
            />
          }
        />
      )}

      {showAdminSetPaidModal && (
        <GenericModal
          init={() => setShowAdminSetPaidModal(false)}
          div={
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                padding: "20px",
                minWidth: "280px",
                direction: "rtl",
                textAlign: "right",
              }}
            >
              <Label style={{ display: "block", marginBottom: "8px" }}>
                סיסמת מנהל
              </Label>
              <Input
                type="password"
                value={adminSetPaidPassword}
                onChange={(e) => setAdminSetPaidPassword(e.target.value)}
                style={{ marginBottom: "12px", width: "100%" }}
                autoComplete="off"
              />
              <Label style={{ display: "block", marginBottom: "8px" }}>
                כמות רשומות
              </Label>
              <Input
                type="number"
                min="0"
                value={adminSetPaidAmountInput}
                onChange={(e) => setAdminSetPaidAmountInput(e.target.value)}
                style={{ marginBottom: "16px", width: "100%" }}
              />
              <FlexRowBetween style={{ gap: "8px" }}>
                <Button type="button" onClick={handleAdminSetPaidModalSubmit}>
                  שליחה
                </Button>
                <Button
                  type="button"
                  onClick={() => setShowAdminSetPaidModal(false)}
                  style={{ background: "#e0e0e0", color: "#333" }}
                >
                  ביטול
                </Button>
              </FlexRowBetween>
            </div>
          }
        />
      )}
    </PopupForm>
  );
};

export default EditUser;
